"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styles_1 = __importDefault(require("./styles"));
// tslint:disable-next-line: max-line-length
var Input = function (_a) {
    var initialValue = _a.initialValue, onChange = _a.onChange, className = _a.className, _b = _a.type, type = _b === void 0 ? 'text' : _b, isHidden = _a.isHidden, placeholder = _a.placeholder, isDisabled = _a.isDisabled, isInvalid = _a.isInvalid, style = _a.style, form = _a.form;
    var _c = react_1.useState(initialValue !== null && initialValue !== void 0 ? initialValue : ''), value = _c[0], setValue = _c[1];
    var handleChange = function (event) {
        var nextValue = event.currentTarget.value;
        setValue(nextValue);
        if (onChange)
            onChange(nextValue);
    };
    react_1.useEffect(function () {
        if (form)
            form.addEventListener('reset', setValue.bind(undefined, ''));
    }, [form]);
    if (isHidden)
        return null;
    var classNames = (className || '') + " " + (isInvalid ? 'invalid' : '');
    return (react_1.default.createElement(styles_1.default, { className: classNames, type: type, placeholder: placeholder, onChange: handleChange, disabled: isDisabled, style: style, value: value }));
};
exports.default = Input;
//# sourceMappingURL=index.js.map